var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 6.25033H5.41634V3.75033H6.66634L4.99967 1.66699L3.33301 3.75033H4.58301V6.25033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 7.49967H1.66634V4.58301H0.833008V7.49967C0.833008 7.95926 1.20676 8.33301 1.66634 8.33301H8.33301C8.79259 8.33301 9.16634 7.95926 9.16634 7.49967V4.58301H8.33301V7.49967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOutline);
export default __webpack_public_path__ + "static/media/uploadOutline.fcbfa8a1894959e761ebf4122c4d7c48.svg";
export { ForwardRef as ReactComponent };